export default {
  ADD_TEAM(state, team) {
    var newTeam = new Object;
    Object.assign(newTeam, team);

    state.currentTeamsList.push(newTeam);
  },
};
